import React from "react";

export type DistributionKpiCardProps = {
  label: string;
  value: string | number;
  subtitle?: string;
  accent: "blue" | "red" | "gray" | "green" | "purple";
};

const ACCENT_COLORS: Record<DistributionKpiCardProps["accent"], string> = {
  blue: "bg-blue-500",
  red: "bg-red-500",
  gray: "bg-slate-400",
  green: "bg-emerald-500",
  purple: "bg-violet-500",
};

export const DistributionKpiCard: React.FC<DistributionKpiCardProps> = ({
  label,
  value,
  subtitle,
  accent,
}) => (
  <div className="relative flex min-h-[88px] overflow-hidden rounded-xl border border-slate-200 bg-white px-4 py-3 dark:border-slate-700/60 dark:bg-[#161b2b]">
    <div className={`absolute left-0 top-0 h-full w-1 ${ACCENT_COLORS[accent]}`} />
    <div className="pl-2">
      <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400">
        {label}
      </p>
      <p className="mt-1 text-2xl font-bold leading-none text-slate-900 dark:text-white sm:text-3xl">
        {value}
      </p>
      {subtitle ? (
        <p className="mt-1.5 text-xs text-slate-500 dark:text-slate-400">{subtitle}</p>
      ) : null}
    </div>
  </div>
);

export default DistributionKpiCard;
